module.exports = __webpack_public_path__ + "static/img/4.95af637.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/scheme/4.jpg
// module id = W7oF
// module chunks = 1